//import type {BffResponse} from '@esofertasv2/bff';
import { Spinner, styled } from '@volkswagen-onehub/components-core';
import React, { useContext, useEffect, useState } from 'react';
import { Ofertas } from './components/ofertas';
import { OfertasContext } from './context/ofertas-context';
import { getDisclaimers, RegisteredDisclaimer } from './helpers/get-disclaimer';
import { getFinanciacionType } from './helpers/ofertas-helper';
import { useDisclaimerReference } from './helpers/useDisclaimerReference';
import {
	CarlineWithOfertas,
	filtersFaContentOfertas,
} from './services/ofertas-service/models/ofertas';
import { useTrackingManager } from './tracking/use-tracking-manager';
import { setGlobalDisclaimer } from './utils/set-global-disclaimer';

const Content = styled.div`
	background-color: white;
	padding: 44px 31px;
	flex: auto;
	text-align: center;
	width: 100%;
	margin-top: 10%;

	@media screen and (min-width: 560px) {
		padding: 52px 46px;
	}

	@media screen and (min-width: 960px) {
		padding: var(--size-grid001);
	}
`;

export function Home(): JSX.Element {
	const {
		disclaimerManager,
		layerManager,
		pageInfoService,
		breacrumbService,
		ofertasService,
		contentService,
	} = useContext(OfertasContext);

	const [carlines, setCarlines] = useState<CarlineWithOfertas[]>([]);
	const [selectedMotorizacion, setSelectedMotorizacion] =
		useState<string>('Todos');
	const [isMotorizacionSelected, setIsMotorizacionSelected] =
		useState<boolean>(false);
	const [errorOffers, setErrorOffers] = useState<string>();
	const [disclaimers, setDisclaimers] = useState<RegisteredDisclaimer[]>([]);
	const [hasOneCarline, setHasOneCarline] = useState<boolean>(false);

	const filtersFaContentOfertas =
		contentService?.content as filtersFaContentOfertas;

	const trackingManager = useTrackingManager();

	const scopedDisclaimerManager =
		disclaimerManager.getScopedDisclaimerManager();

	useDisclaimerReference(disclaimers);
	setGlobalDisclaimer(scopedDisclaimerManager);

	const handleFilteredCarlines = (selectedButton: string) => {
		setSelectedMotorizacion(selectedButton);
		setIsMotorizacionSelected(true);

		setCarlines([]);
	};

	//Detect author mode
	const params = new URLSearchParams(window.location.search);
	const authorMode = params.get('appId') == 'aemshell' ? true : false;

	useEffect(() => {
		breacrumbService.set([]);
		pageInfoService.setPageInfo();
	}, [pageInfoService, breacrumbService]);

	useEffect(() => {
		ofertasService
			.getOfertas(filtersFaContentOfertas?.carlines)
			.then((carlines) => {
				setCarlines(carlines);
				const currentDisclaimers = getDisclaimers(carlines);

				if (carlines.length === 1) {
					setHasOneCarline(true);
				}

				setDisclaimers(currentDisclaimers);
			})
			.catch((error) => {
				console.error('Error al obtener las ofertas:', error);
				setErrorOffers(error);
			});
	}, [filtersFaContentOfertas?.carlines, ofertasService]);

	useEffect(() => {
		let index = 0;
		if (selectedMotorizacion === 'Combustión') {
			index = 1;
			setCarlines(ofertasService.getOfertasCombustion());
		} else if (selectedMotorizacion == 'Híbridos enchufables') {
			index = 2;
			setCarlines(ofertasService.getOfertasHibrido());
		} else if (selectedMotorizacion == 'Eléctricos') {
			index = 3;
			setCarlines(ofertasService.getOfertasElectrico());
		} else {
			index = 0;
			setCarlines(ofertasService.getOfertasBaseFiltered());
		}

		if (!isMotorizacionSelected && carlines.length > 0) {
			trackingManager.trackOfertasGenericFeatureAppLoad({
				CarlineId: carlines[0].code.toString(),
				CarlineName: carlines[0].title,
				SalesgroupName: carlines[0].ofertas[0]?.carline?.salesgroup.title,
				ModelId: carlines[0].ofertas[0]?.motorizacionCode?.split('-')[0],
				ModelName: carlines[0].ofertas[0]?.carline?.salesgroup.model.name,
				ModelYear: carlines[0].ofertas[0]?.carline?.salesgroup.year.toString(),
				PriceRateType: getFinanciacionType(carlines[0].ofertas[0]),
				PriceRateTotal: carlines[0].ofertas[0]?.cuota ?? undefined,
				PriceRateCurrency: 'EUR',
				PriceTotalTotal: carlines[0].ofertas[0]?.precio ?? undefined,
				PriceTotalCurrency: 'EUR',
			});
		}

		if (isMotorizacionSelected && carlines.length > 0) {
			trackingManager.trackOfertasVehiclePageload({
				CarlineId: carlines[0].code.toString(),
				CarlineName: carlines[0].title,
				SalesgroupName: carlines[0].ofertas[0]?.carline?.salesgroup.title,
				ModelId: carlines[0].ofertas[0]?.motorizacionCode?.split('-')[0],
				ModelName: carlines[0].ofertas[0]?.carline?.salesgroup.model.name,
				ModelYear: carlines[0].ofertas[0]?.carline?.salesgroup.year.toString(),
				PriceRateType: getFinanciacionType(carlines[0].ofertas[0]),
				PriceRateTotal: carlines[0].ofertas[0]?.cuota ?? undefined,
				PriceRateCurrency: 'EUR',
				PriceTotalTotal: carlines[0].ofertas[0]?.precio ?? undefined,
				PriceTotalCurrency: 'EUR',
			});

			setIsMotorizacionSelected(false);
		}
	}, [carlines, selectedMotorizacion, ofertasService]);

	return (
		<>
			{!authorMode && carlines.length > 0 ? (
				<Ofertas
					carlines={carlines}
					hasOneCarline={hasOneCarline}
					handleFilteredCarlines={handleFilteredCarlines}
					selectedMotorizacion={selectedMotorizacion}
					setSelectedMotorizacion={setSelectedMotorizacion}
				/>
			) : errorOffers ? (
				<></>
			) : (
				<Content>
					<Spinner variant="x-large" />
				</Content>
			)}
		</>
	);
}
